import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';
import useFeatureDiscoveryFeatureDiscoveryQuery, {
	type useFeatureDiscoveryFeatureDiscoveryQuery$data,
	type useFeatureDiscoveryFeatureDiscoveryQuery$variables,
} from './__generated__/useFeatureDiscoveryFeatureDiscoveryQuery.graphql.ts';
import type { GraphQLError } from 'graphql';

export const preloadFeatureDiscovery = (): Promise<{
	data: useFeatureDiscoveryFeatureDiscoveryQuery$data | null;
	errors?: ReadonlyArray<GraphQLError>;
	hasErrors: boolean;
}> => {
	return query<
		useFeatureDiscoveryFeatureDiscoveryQuery$data,
		useFeatureDiscoveryFeatureDiscoveryQuery$variables
	>({
		query: useFeatureDiscoveryFeatureDiscoveryQuery,
	});
};
